'use client';

import Link from 'next/link';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { center } from '@flipster/styled-system/patterns';
import DocumentHistoryIcon from '@flipster/ui/assets/svgs/document-history.svg';

export const HistoryLink = () => {
  const { isCookieLoggedIn } = useAuth();
  return (
    <Link
      className={center({ color: 'content.default.level-5' })}
      href='/history/earn'
      prefetch={isCookieLoggedIn}
      target='_blank'
    >
      <DocumentHistoryIcon />
    </Link>
  );
};
